/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_Preset_AriaInputs */

const en_video_export_style_preset_aria = /** @type {(inputs: Video_Export_Style_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style Preset Selection`)
};

const fr_video_export_style_preset_aria = /** @type {(inputs: Video_Export_Style_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selection du prereglage de style`)
};

const de_video_export_style_preset_aria = /** @type {(inputs: Video_Export_Style_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stilvoreinstellungsauswahl`)
};

const it_video_export_style_preset_aria = /** @type {(inputs: Video_Export_Style_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione predefinita di stile`)
};

const ru_video_export_style_preset_aria = /** @type {(inputs: Video_Export_Style_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор предустановленного стиля`)
};

const es_video_export_style_preset_aria = /** @type {(inputs: Video_Export_Style_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de ajustes preestablecidos de estilo`)
};

const zh_cn2_video_export_style_preset_aria = /** @type {(inputs: Video_Export_Style_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`样式预设选择`)
};

const ja_video_export_style_preset_aria = /** @type {(inputs: Video_Export_Style_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルプリセットの選択`)
};

const hi_video_export_style_preset_aria = /** @type {(inputs: Video_Export_Style_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल प्रीसेट चयन`)
};

const pt_pt2_video_export_style_preset_aria = /** @type {(inputs: Video_Export_Style_Preset_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção de predefinições de estilo`)
};

/**
* | output |
* | --- |
* | "Style Preset Selection" |
*
* @param {Video_Export_Style_Preset_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_preset_aria = /** @type {((inputs?: Video_Export_Style_Preset_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_Preset_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_style_preset_aria(inputs)
	if (locale === "de") return de_video_export_style_preset_aria(inputs)
	if (locale === "it") return it_video_export_style_preset_aria(inputs)
	if (locale === "ru") return ru_video_export_style_preset_aria(inputs)
	if (locale === "es") return es_video_export_style_preset_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_style_preset_aria(inputs)
	if (locale === "ja") return ja_video_export_style_preset_aria(inputs)
	if (locale === "hi") return hi_video_export_style_preset_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_style_preset_aria(inputs)
	return en_video_export_style_preset_aria(inputs)
});